import { render, staticRenderFns } from "./NavDrawerHeader.vue?vue&type=template&id=06d0d4ea&scoped=true"
import script from "./NavDrawerHeader.vue?vue&type=script&lang=js"
export * from "./NavDrawerHeader.vue?vue&type=script&lang=js"
import style0 from "./NavDrawerHeader.vue?vue&type=style&index=0&id=06d0d4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d0d4ea",
  null
  
)

export default component.exports